import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { BusyTreeComponent } from "./busy-tree/busy-tree.component";
import { BusyService, IBusyChannel } from "./busy.service";

@Component({
    selector: "rask-busy",
    styleUrls: ["./busy.component.scss"],
    templateUrl: "./busy.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BusyTreeComponent]
})
export class BusyComponent implements OnInit, OnDestroy {
    channel: IBusyChannel;
    isWorking = false;
    label: string;

    private readonly authService = inject(AuthenticationService);
    private readonly busyService = inject(BusyService);
    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly destroy$ = new Subject<void>();

    close() {
        this.busyService.stopWork(this.channel.channel);
    }

    ngOnDestroy(): void {
        this.channel.isWorking.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.channel = this.busyService.getChannel();
        this.channel.isWorking.subscribe(working => {
            this.isWorking = working;
            this.label = this.channel.label;
            this.cdRef.detectChanges();
        });

        this.waitForLoginBeforeFeatureInit();
    }

    waitForLoginBeforeFeatureInit() {
        requestAnimationFrame(() => {
            this.authService.userStateChanged.pipe(
                takeUntil(this.destroy$)
            ).subscribe(loggedin => {
                if (!loggedin) {
                    return;
                }
            });
        });
    }

    protected getLabel() {
        if(this.channel.label === BusyService.defaultLabel) {
            return "Var god vänta, sidan laddar..";
        }else{
            return this.channel.label;
        }
    }
}
